export * from './application'
export * from './asset'
export * from './reservation'
export * from './template'
export * from './file';
export * from './form';
export * from './MetricActions';
export * from './AddressActions';
import { useLookupActions } from './LookupActions'
import { useTagActions } from './TagActions'
import { useMetricActions } from './MetricActions'
import { useSystemActions } from './SystemActions'
import { useIamActions } from './IamActions'
import { useAddressActions } from './AddressActions'
import { useOrganizationActions } from './OrganizationActions'
import { useFlagActions } from './FlagActions'
import { useApplicationActions } from './ApplicationActions'
import { useZumrailsActions } from './ZumrailsActions'
import { usePaymentActions } from './PaymentActions'
import { useLegalEntityActions } from './LegalEntity'
import { useAssetActions } from './AssetActions'
import { useReservationActions } from './ReservationActions'
import { useNotificationActions } from './NotificationActions'
import { useContractActions } from './ContractActions'
import { PmStore } from '@/state'
import { useInvoiceActions } from './InvoiceActions';
export * from './ApplicationActions';
export * from './InvoiceActions';

export function useRentalFlowApi() {
    return {
        state: PmStore(),
        lookups: useLookupActions(),
        tags: useTagActions(),
        metrics: useMetricActions(),
        system: useSystemActions(),
        iam: useIamActions(),
        address: useAddressActions(),
        organization: useOrganizationActions(),
        flag: useFlagActions(),
        application: useApplicationActions(),
        zumrails: useZumrailsActions(),
        payments: usePaymentActions(),
        legalEntity: useLegalEntityActions(),
        asset: useAssetActions(),
        reservation: useReservationActions(),
        notification: useNotificationActions(),
        contract: useContractActions(),
        invoice: useInvoiceActions()
    };
}
